module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Light-29c3ba9507f7cd726f4734d402bba683.ttf";